import gql from 'graphql-tag'

export const GET_META_TAG = gql`
  query metatag($chave: String!) {
    metatag(chave: $chave) {
      valor
    }
  }
`
